export enum ReturnOrderReason {
    UnknownReason = "UnknownReason",
    ReturnToDealer = "ReturnToDealer",
    ScrapForDealer = "ScrapForDealer",
}
